export default {"src":"/_next/static/media/icon-parking.8f2c3c80.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};